import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Logo_wordmark_lightbg.svg';
import { buildSignupPath, buildSignupState, captureCtaClick, captureOutboundLinkClick } from '../utils/analytics';

function Footer() {
  return (
    <footer className="bg-[#f5f5f7] px-8 md:px-16 py-16">
      <div className="max-w-[1440px] mx-auto flex flex-col gap-12">

        {/* Top row */}
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-center md:justify-between md:gap-16">
          <img src={logo} alt="MedHug" className="h-10 w-auto flex-shrink-0" />

          <div className="flex flex-col items-start gap-4 md:flex-row md:items-center md:gap-8">
            <Link to="/about" className="text-[15px] text-[#424245] hover:text-[#1d1d1f] transition-colors">About Us</Link>
            <Link to="/resources" className="text-[15px] text-[#424245] hover:text-[#1d1d1f] transition-colors">Resources</Link>
            <Link to="/news" className="text-[15px] text-[#424245] hover:text-[#1d1d1f] transition-colors">Latest News</Link>
          </div>

          <Link
            to={buildSignupPath()}
            state={buildSignupState('footer-contact')}
            data-ph-capture-attribute-cta="footer-contact"
            onClick={() => captureCtaClick('footer-contact', { placement: 'footer' })}
            className="text-[15px] text-[#06c] font-medium hover:text-[#004aad] transition-colors whitespace-nowrap"
          >
            Contact Us →
          </Link>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#d2d2d7]" />

        {/* Bottom row */}
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col items-start gap-3 text-sm text-[#424245] md:flex-row md:items-center md:gap-6">
            <span>© 2026 MedHug. All rights reserved.</span>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://x.com/MedHug"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#424245] hover:text-[#1d1d1f] transition-colors"
              aria-label="X"
              onClick={() => captureOutboundLinkClick('footer-x', 'https://x.com/MedHug', { placement: 'footer' })}
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.734-8.835L1.254 2.25H8.08l4.253 5.622 5.91-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/medhug" target="_blank" rel="noopener noreferrer" className="text-[#424245] hover:text-[#1d1d1f] transition-colors" aria-label="LinkedIn" onClick={() => captureOutboundLinkClick('footer-linkedin', 'https://www.linkedin.com/company/medhug', { placement: 'footer' })}>
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
